export default {
  common: {
    language: "语言",
    switchToEnglish: "切换为英文",
    switchToChinese: "切换为中文",
    switchLang: "切换语言",
    confirm: "确认",
    cancel: "取消",
    noData: "暂无数据",
    confirm: "确定",
    cancel: "取消",
    pleaseLogin: "请登录",
    paymentFailed: "支付失败，请重试",

    goHome: "回到首页",
  },
  login: {
    registerTitle: "注册成功!",
    registerSuccess: "注册成功!恭喜您成为yoyotravel 会员!您已获得 RM",
    registerSuccessDesc: " 新人优惠券，赶快去使用吧~",
    loggout: "退出登录",
    logoutConfirm: "确定要退出登录吗？",
  },
  tabbar: {
    home: "首页",
    discover: "发现",
    bookings: "订单",
    mine: "我的",
  },
  home: {
    title: "首页",
    esim: "eSIM",
    sim: "SIM",
    search: "查询",
    searchPlaceholder: "搜索房源、地点",
    hot: "热门",
    searchText: "搜索出行目的地",
    favoriteCount: "人收藏",
    destinationNotExist: "该目的地已不存在，请重新搜索",
    recentSearch: "最近搜索",
    guessYouWantToSearch: "猜你想搜",
    popularRecommend: "热门推荐",
    features: {
      register: "一键注册会员，享有各种优惠！",
      discount: "赚取Yoyo币可折抵现金！",
      packages: "覆盖190+国家流量套餐供您选择！",
      esimFree: "无需等待，下单esim自动发货！",
      simple: "激活简单，网络快速又好用！",
      gifts: "还有生日大礼包、活动优惠、旅游套餐等惊喜等您！",
    },
    dialog: {
      login: {
        title: "会员注册/登录",
        registerDesc: "请输入邮箱进行注册/登录",
        codeDesc: "验证码已发送到",
        codeDesc2: "，请在 5 分钟内输入验证码完成验证",
        codeTip: '如未收到，请检查垃圾邮箱，或稍后点击"重新发送"',
        codePlaceholder: "请输入邮箱",
        passwordPlaceholder: "请输入密码",
        codeLogin: "邮箱验证码"
      },
      tip: {
        languageTitle: "欢迎来到yoyotravel!",
        languageDesc: "欢迎来到yoyotravel！请选择您希望使用的语言",
        passwordTitle: "设置密码",
        passwordDesc: "为保障您的账户安全，请您尽快设置登录密码，以便后续快捷访问与信息保护～",
        reviewTitle: "您有待评价订单",
        reviewDesc1: "上次的订单还没评价呢！",
        reviewDesc2: "分享5星好评，立刻赚取",
        reviewDesc3: "个yoyo币！",
        reviewDesc4: "可用于消费折抵 RM",
        reviewDesc5: "哦~",
        laterText: "下次再说",
        setPasswordText: "设置密码",
        chinesetext: "简体中文",
        englishText: "en English",
        reviewText: "去评价",
        rm5CouponText: "即可领取RM5新人券",
        iKnowText: "我知道了",
        reviewText: "立即评价",
      },
      register: { 
        title: "注册领取 RM5",
        registerDesc: "输入邮箱，轻松注册，马上享有专属优惠！",
        inviteRegisterDesc1: "您的邀请码为",
        inviteRegisterDesc2: "快来注册领取RM5新人券吧！",
      },
    },
    buttons: {
      next: "下一步",
      login: "登录",
      register: "注册",
      resend: "重新发送",
    },
  },
  products: {
    listNavTitle: "产品列表",
    navTitle: "购物车",
    showMore: "查看更多",
    showLess: "收起",
    showAll: "查看全部",
    reviews: "评价",
    selectAll: "全选",
    pleaseSelectProducts: "请选择结算的产品",
    cardEmpty: "购物车是空的",
    cardDesc1: "西马满 RM60 即享免运；东马满 RM100 即享免运！",
    cardDesc2: "满RM350即可获得惊喜赠品！",
    cardDesc3: "立即注册，新人可享有RM",
    cardDesc8: "折扣！",
    cardDesc4: "免运费",
    cardDesc5: "会员将获得",
    cardDesc6: "yoyo币",
    cardDesc7: "可抵扣RM",
    cardBtnText1: "点击注册",
    cardBtnText2: "去结账",
    payNavTitle: "支付详情",
    // Product detail page translations
    quantity: "数量",
    price: "价格",
    addToCart: "加入购物车",
    buyNow: "立即购买",
    selectRegion: "选择地区",
    addedToCart: "已加入购物车",
    days: "天数",
    packages: "套餐",
    reviewCount: "条评价",
    // Payment method translations
    paymentMethod: "付款方式",
    creditCard: "信用卡/借记卡",
    onlineBanking: "网上银行",
    eWallet: "电子钱包",
    bankCard: "银行卡",
    cardHolder: "持卡人",
    expiryDate: "到期日",
    cvv: "CVV",
    saveCardInfo: "保存银行卡信息",
    cardNumberPlaceholder: "请输入银行卡号",
    cardHolderPlaceholder: "请输入持卡人姓名",
    expiryMonthPlaceholder: "请输入月份",
    expiryYearPlaceholder: "请输入年份",
    cvvPlaceholder: "请输入CVV",
    // Pay page translations
    shippingAddress: "邮寄地址",
    shippingAddressPlaceholder: "请输入邮寄地址",
    shippingAddressRequired: "请填写邮寄地址",
    recipient: "收件人",
    recipientPlaceholder: "请输入收件人姓名",
    areaCodePlaceholder: "请选择区号",
    recipientRequired: "请填写收件人姓名",
    phoneNumber: "电话号码",
    phoneNumberPlaceholder: "请输入电话号码",
    phoneNumberRequired: "请填写电话号码",
    emailAddress: "邮箱地址",
    emailAddressRequired: "请填写邮箱地址",
    emailFormatError: "请输入正确的邮箱格式",
    subscribeMarketing: "我同意接收促销邮件、优惠活动和产品最新消息",
    nonMember: "非会员？",
    oneClickRegister: "一键注册会员",
    getRm5Coupon: "即可领取RM",
    getRm5Coupon2: "新人券！",
    loginEarnCoins: "立即登录，赚取yoyo币",
    oneClickLogin: "一键登录",
    subtotal: "商品小计",
    shippingFee: "运费金额",
    freeShippingNote: "(西马满RM60免运费；东马满RM100免运费)",
    currentYoyoCoins: "当前yoyo币为",
    availableYoyoCoins: "，可使用的yoyo币",
    yoyoDiscount: "（折抵RM",
    coupon: "优惠券",
    totalAmount: "付款总额",
    registerMember: "注册会员",
    registerMemberDiscount: "可领取RM5折扣券",
    loginMember: "登录会员",
    loginMemberDiscount: "可赚取",
    yoyoCoins: "个yoyo币",
    checkout: "结 账",
    jumpToRegister: "跳转到注册页面",
    jumpToLogin: "跳转到登录页面",
    yoyoUsed: "已使用YoYo币，优惠RM",
    couponSelected: "已选择优惠券：",
    completeShippingInfo: "请完善收货信息",
    completePaymentInfo: "请选择支付方式",
    processingPayment: "正在处理支付...",
    paymentSuccess: "支付成功！",
    yoyoPointNotEnough: "YoYo币不足",
    day: "天",
    days: "天",
    paymentChannel: "支付渠道",
    shopQuantity: "商品数量",
    detail: {
      coverRegion: "覆盖区域",
      productIntro: "产品简介",
      operator: "运营商",
      delivery: "发货时间",
      notice: "注意事项",
      activation: "激活方式",
      supportDevice: "支持设备",
      productFAQ: "产品FAQ",
      yoyoCoin: "YoYo币",
    },
    settleErr: "获取结算价格失败，请重试",
    addressErr: "获取默认地址失败，请重试",
  },
  query: {
    title: "查询",
    date: "日期",
    queryDate: "查询日期",
    country: "国家",
    status: "状态",
    usage: "用量",
    statusActive: "活跃",
    statusExpired: "已过期",
    statusPending: "待激活",
    noMoreData: "没有更多了",
    loading: "加载中...",
    refreshing: "刷新中...",
    bindToAccount: "绑定到我的账户",
    recharge: "充值",
    searchText: "输入SIM ID / iccid ",
    alreadyUsed: "已使用流量: ",
    tip: "流量使用数据可能存在延迟，请以实际使用为准。",
  },
  discover: {
    description: "探索更多精彩内容",
  },
  bookings: {
    description: "查看您的订单记录",
  },
  mine: {
    description: "个人中心",
    malaysia: "马来西亚",
    explorer: "探索者",
    joined: "已加入",
    years: "年",
    personalInfo: "个人资料",
    myBadges: "我的微章",
    currentPoints: "当前共累计",
    points: "币",
    currentLevel: "当前等级",
    myYoyoCoins: "我的yoyo币",
    accumulated: "已累计",
    used: "已使用",
    discountRM: "已折抵RM",
    expireInMonths: "币还有xxx个月即将过期",
    myCoupons: "我的优惠券",
    unused: "未使用",
    newUserRM5: "新人券RM5",
    validUntil2025: "有效期至",
    pieces: "张",
    myOrders: "我的订单",
    reviews: "我的评价",
    toDo: "我的代办",
    favorites: "我的收藏",
    binds: "我的绑定",
    language: "语言选择",
    customerService: "官方客服",
  },
  userInfo: {
    title: "个人资料",
    name: "名称",
    gender: "性别",
    birthday: "生日",
    country: "国家",
    changePassword: "更改密码",
    email: "电邮",
    phone: "电话号码",
    address: "地址",
    bankCard: "银行账号/信用卡",
    malaysia: "马来西亚",
    noReveal: "不透露",
    male: "男",
    female: "女",
    default: "默认",
    addAddress: "新增地址",
    addBankCard: "新增账号/卡号",
    editName: "编辑姓名",
    editEmail: "编辑邮箱",
    editPhone: "编辑电话",
    namePlaceholder: "请输入姓名",
    genderPlaceholder: "请选择性别",
    birthdayPlaceholder: "请选择生日",
    countryPlaceholder: "请输入国家",
    emailPlaceholder: "请输入邮箱地址",
    phonePlaceholder: "请输入电话号码",
    passwordPlaceholder: "请输入密码",
    updateUserInfo: "更新用户信息",
    updateSuccess: "更新成功",
    changePasswordSuccess: "密码修改成功",
    areaCode: "地区编码",
    postalCode: "邮政编码",
    areaCodePlaceholder: "请输入地区编码",
    postalCodePlaceholder: "请输入邮政编码",
  },
  address: {
    addAddress: "新增地址",
    editAddress: "编辑地址",
    name: "姓名",
    phone: "电话",
    country: "国家",
    city: "城市",
    region: "地区",
    detailAddress: "详细地址",
    zipCode: "邮政编码",
    setAsDefault: "设为默认收货地址",
    save: "保存",
    delete: "删除",
    namePlaceholder: "请输入收货人姓名",
    phonePlaceholder: "请输入收货人手机号",
    phoneNumberPlaceholder: "收货人手机号",
    countryCodePlaceholder: "国际区号",
    countryCodeRequired: "请选择国际区号",
    countryPlaceholder: "请选择国家",
    cityPlaceholder: "请选择城市",
    zipCodePlaceholder: "请输入区号",
    regionPlaceholder: "选择省/市/区",
    detailAddressPlaceholder: "街道门牌、楼层房间号等信息",
    nameRequired: "请输入收货人姓名",
    phoneRequired: "请输入收货人手机号",
    regionRequired: "请选择收货地区",
    detailAddressRequired: "请输入详细地址",
    addSuccess: "添加地址成功",
    updateSuccess: "更新地址成功",
    deleteSuccess: "删除地址成功",
    saveError: "保存地址失败",
    deleteError: "删除地址失败",
    deleteConfirm: "删除地址",
    deleteMessage: "确定要删除这个地址吗？",
  },
  bankCard: {
    addBankCard: "新增银行卡",
    editBankCard: "编辑银行卡",
    name: "姓名",
    cardNo: "卡号",
    expireDate: "过期日期",
    checksum: "cvv",
    setAsDefault: "设为默认银行卡",
    save: "保存",
    delete: "删除",
    namePlaceholder: "请输入持卡人姓名",
    cardNoPlaceholder: "请输入银行卡号",
    expireDatePlaceholder: "请选择过期日期",
    checksumPlaceholder: "请输入cvv",
    nameRequired: "请输入持卡人姓名",
    cardNoRequired: "请输入银行卡号",
    expireDateRequired: "请选择过期日期",
    checksumRequired: "请输入cvv",
    addSuccess: "添加银行卡成功",
    updateSuccess: "更新银行卡成功",
    deleteSuccess: "删除银行卡成功",
    saveError: "保存银行卡失败",
    deleteError: "删除银行卡失败",
    deleteConfirm: "删除银行卡",
    deleteMessage: "确定要删除这张银行卡吗？",
  },
  yoyoCoins: {
    title: "我的yoyo币",
    currentBalance: "当前yoyo币",
    expireDate: "币将于",
    expireText: "过期",
    accumulated: "已累计",
    used: "已使用",
    discountRM: "已折抵",
    received: "已收到",
    usageRecord: "使用记录",
    purchaseEsim: "购买eSIM/SIM卡",
    fiveStarReview: "5星评价",
    completeProfile: "完善个人资料",
    systemReward: "系统自动奖励",
    signInSuccess: "签到成功",
    signInSuccessTitle: "恭喜！",
    signInSuccessDesc: " 个 yoyo 币已存入您的口袋，下单时可直接抵扣金额哦～",
  },
  reviews: {
    title: "我的评价",
    totalReviews: "已评价",
    totalYoyoCount: "已获得",
    reviewsCount: "条评价",
    pendingReviews: "待评价",
    completedReviews: "已评价",
    tabs: {
      pending: "待评价",
      completed: "已评价",
    },
    orderNumber: "订单号",
    productName: "产品名称",
    orderDate: "订单日期",
    reviewButton: "评价",
    reviewCompleted: "已评价",
    reviewTime: "评价时间",
    rating: "评分",
    reviewContent: "评价内容",
    noReviews: "暂无评价",
    noPendingReviews: "暂无待评价订单",
    noCompletedReviews: "暂无已评价订单",
    loadMore: "加载更多",
    refreshing: "刷新中...",
    loading: "加载中...",
    stars: "星",
    reviewPlaceholder: "请输入您的评价内容...",
    submitReview: "提交评价",
    reviewSuccess: "评价成功",
    reviewFailed: "评价失败，请重试",
    publish: "发布",
    reviewMinLength: '请输入至少5个字符'
  },
  binds: {
    title: "我的绑定",
    simCard: "SIM卡",
    esim: "eSIM",
    iccid: "iccid",
    activated: "已激活",
    notActivated: "未激活",
    exchanged: "已兑换",
    finished: "已完成",
    expired: "已失效",
    query: "查询",
    recharge: "充值",
    deleteBinding: "删除绑定",
    newBinding: "新增绑定",
    note: "注: SIM卡激活后180天内可续充任一套餐，无需换卡",
    noBindings: "暂无绑定的SIM卡",
    confirmDelete: "确认删除绑定？",
    deleteSuccess: "删除成功",
    deleteFailed: "删除失败",
    addBindingPlaceholder: "请输入iccid",
    deadline: "截止日期",
  },
  orders: {
    title: "我的订单",
    orderNumber: "订单号",
    orderTime: "下单时间",
    productContent: "产品内容",
    totalAmount: "总金额",
    couponUsed: "使用优惠券",
    status: "状态",
    statusProcessing: "待支付",
    statusPending: "待发货",
    statusShipped: "已发货",
    statusDelivered: "已完成",
    statusCancelled: "已取消",
    noCoupon: "未使用优惠券",
    noOrders: "暂无订单",
    viewDetails: "查看详情",
    cancelOrder: "取消订单",
    confirmCancel: "确认取消订单？",
    cancelSuccess: "订单取消成功",
    cancelFailed: "订单取消失败",
  },
  orderDetail: {
    title: "订单详情",
    productInfo: "商品信息",
    orderAmount: "订单金额",
    productAmount: "商品金额",
    yoyoCoinDiscount: "yoyo币抵扣金额",
    couponDiscount: "优惠券优惠金额",
    shippingFee: "运费",
    actualAmount: "实付款",
    receiverInfo: "收货信息",
    receiverName: "收货人",
    receiverPhone: "联系电话",
    receiverAddress: "收货地址",
    email: "邮箱",
    logisticsInfo: "物流信息",
    logisticsCompany: "物流公司",
    trackingNumber: "物流单号",
    shippingTime: "发货时间",
    orderInfo: "订单信息",
    orderNumber: "订单编号",
    serialNumber: "订单流水号",
    createTime: "创建时间",
    payTime: "支付时间",
    rePay: "继续支付"
  },
  badges: {
    title: "我的徽章",
    currentLevel: "当前等级",
    nextLevel: "下个等级",
    needPoints: "还需累积",
    canUpgrade: "即可升级",
    badgeList: "徽章等级",
    benefitsComparison: "权益对比",
    benefit: "徽章等级",
    points: "累积",
    consumeRM1: "消费RM1可获得",
    birthdayBenefit: "生日福利",
    exclusiveBenefit: "专属福利",
    yoyoCoinValid: "Yoyo币永久有效",
    freeShipping: "无门槛包邮",
    customerService: "客服服务",
  },
  todo: {
    title: "我的代办",
    completePersonalInfo: "完善个人资料",
    share: "社交媒体分享",
    commentOnTheOrder: "分享5星好评",
    complete3Orders: "完成3个订单",
    complete6Orders: "完成6个订单",
    dailyAttendance: "每日签到",
    recommend: "推荐好友",
    register: "新会员注册",
    contactService: "联系客服",
    toComplete: "去完成",
    copyLink: "复制链接",
    progress: "进度",
    completed: "完成",
    copySuccess: "复制成功",
    goCollect: "去签到",
    completed1: "已完成",
    ongoing: "待完成",
  },

  foot: {
    about: "关于我们",
    contact: "联系方式",
    follow: "关注我们",
    payment: "付款渠道",
  },
  coupons: {
    available: "可使用",
    used: "已使用",
    expired: "已过期",
    use: "使用",
    noAvailable: "暂无可用优惠券",
    noUsed: "暂无已使用优惠券",
    noExpired: "暂无已过期优惠券",
    noCoupons: "不使用优惠券",
  },
  pay: {
    title: "支付提示",
    orderTimeout: "订单查询超时，请稍后查询",
    waitingForPayment: "等待支付完成",
    orderSuccess: "订单支付成功",
    PaySuccess: "支付成功",
    PayFailed: "支付失败",
    PayProcessing: "支付处理中...",
    goOrderDetail: "查看订单",
  },
  recharge: {
    title: "充值",
    rechargeNow: "立即充值",
  },
  
}
